import React from 'react';
import useGlobalState from '../hooks/use-global-state';
import {
  selectSubmissionCountsByYear,
  setShowTable as _setShowTable,
} from '../modules/app-duck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { mobileMQ, colors } from '../modules/theme';
import { useIsSmallMobile } from '../hooks/mobile';
import { pixelToRem } from './ui';
import { formatNum } from '../modules/format-number';
const MONTH_LABELS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const CELL_WIDTH = 100 / (MONTH_LABELS.length + 1) + '%';
const getDesktopRows = submissionCountsByYear => {
  return submissionCountsByYear.map(year => {
    const cells = MONTH_LABELS.map((monthLabel, i) => {
      const monthData = year.months.find(month => month.month === monthLabel);
      const cellContent = monthData ? formatNum(monthData.count) : '-';
      return (
        <td
          css={{
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: 12,
            background: colors.reallyDarkBlue,
            borderRadius: 2,
            height: 20,
            lineHeight: '20px',
            width: CELL_WIDTH,
          }}
          key={monthLabel + i}
        >
          {cellContent}
        </td>
      );
    });
    return (
      <tr key={year.year}>
        <td
          css={{
            fontWeight: '600',
            textAlign: 'center',
            fontSize: 12,
            padding: '2px 8px 0 0',
            width: CELL_WIDTH,
          }}
        >
          {year.year}
        </td>
        {cells}
      </tr>
    );
  });
};
const getMobileRows = submissionCountsByYear => {
  return MONTH_LABELS.map(monthLabel => {
    const cells = submissionCountsByYear.map(year => {
      const monthData = year.months.find(month => month.month === monthLabel);

      return (
        <td
          css={{
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: pixelToRem(12),
            background: colors.reallyDarkBlue,
            borderRadius: 2,
            height: 20,
            lineHeight: '20px',
            margin: 1,
            width: 50,
          }}
          key={monthLabel + year.year}
        >
          {monthData ? monthData.count : '-'}
        </td>
      );
    });
    return (
      <tr
        css={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        key={monthLabel}
      >
        <td
          css={{
            fontWeight: 'bold',
            textAlign: 'right',
            fontSize: pixelToRem(12),
            marginRight: 2,
            width: 25,
          }}
          key={monthLabel}
        >
          {monthLabel}
        </td>
        {cells}
      </tr>
    );
  });
};

const getHeader = items => {
  return (
    <tr>
      <th />
      {items.map(item => {
        return (
          <th
            css={{
              fontWeight: 'bold',
              textAlign: 'center',
              fontSize: 12,
              paddingBottom: 6,
            }}
            key={item}
          >
            {item}
          </th>
        );
      })}
    </tr>
  );
};

const getMobileHeaderRow = submissionCountsByYear => {
  const years = Object.keys(
    submissionCountsByYear.reduce((acc, val) => {
      acc[val.year] = val.year;
      return acc;
    }, {})
  );
  return (
    <tr css={{ display: 'flex', justifyContent: 'center' }}>
      <th css={{ width: 20 }} />
      {years.map(item => {
        return (
          <th
            css={{
              fontWeight: 'bold',
              textAlign: 'center',
              fontSize: 12,
              paddingBottom: 6,
              width: 50,
            }}
            key={item}
          >
            {item}
          </th>
        );
      })}
    </tr>
  );
};
export default function MapTable() {
  const { state, dispatch } = useGlobalState();
  const submissionCountsByYear = selectSubmissionCountsByYear(state);
  const isSmallMobile = useIsSmallMobile();

  if (!submissionCountsByYear || !submissionCountsByYear.length) return;

  const setShowTable = visible => dispatch(_setShowTable(visible));
  const headerRow = isSmallMobile
    ? getMobileHeaderRow(submissionCountsByYear)
    : getHeader(MONTH_LABELS);
  const rows = isSmallMobile
    ? getMobileRows(submissionCountsByYear)
    : getDesktopRows(submissionCountsByYear);
  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        borderRadius: '4px',
        [mobileMQ]: {
          overflowX: 'auto',
        },
      }}
    >
      <button
        onClick={() => setShowTable(false)}
        css={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          transition: 'opacity 0.2s',
          opacity: 0.7,
          ':hover': {
            opacity: 1,
          },
          position: 'absolute',
          top: 10,
          right: 10,
        }}
      >
        <FontAwesomeIcon
          style={{
            fontSize: 16,
            color: 'white',
          }}
          icon={faTimes}
        />
      </button>
      <table
        css={{
          color: 'white',
          border: 'none',
          width: '100%',
          height: '100%',
          padding: '28px 48px',
          [mobileMQ]: {
            padding: 20,
          },
        }}
      >
        <thead>{headerRow}</thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
}
